import CompanyBlock from "./CompanyBlock";

export default CompanyBlock;
